import { Qualification, QualificationData } from '../../types/Qualifications';
import { Assessment } from '../../types/Syllabuses';

export const SET_ASSESSMENT = '@QUALIFICATIONS/SET_ASSESSMENT';
export const SET_ASSESSMENT_VERSIONS = '@QUALIFICATIONS/SET_ASSESSMENT_VERSIONS';
export const SET_ASSESSMENT_VERSION = '@QUALIFICATIONS/SET_ASSESSMENT_VERSION';
export const GET_ASSESSMENT_VERSIONS = '@QUALIFICATIONS/GET_ASSESSMENT_VERSIONS';
export const SET_QUALIFICATION = '@QUALIFICATIONS/SET_QUALIFICATION';
export const GET_QUALIFICATIONS = '@QUALIFICATIONS/GET_QUALIFICATIONS';
export const SET_QUALIFICATIONS = '@QUALIFICATIONS/SET_QUALIFICATIONS';
export const SET_ERROR = '@QUALIFICATIONS/SET_ERROR';

export interface GetQualifications {
  type: typeof GET_QUALIFICATIONS;
}

export interface SetQualification {
  type: typeof SET_QUALIFICATION;

  payload: {
    selectedQualification: Qualification;
  };
}
export interface SetAssessment {
  type: typeof SET_ASSESSMENT;

  payload: {
    selectedAssessment: Assessment | undefined;
  };
}

export interface GetAssessmentVersions {
  type: typeof GET_ASSESSMENT_VERSIONS;
}
export interface SetAssessmentVersions {
  type: typeof SET_ASSESSMENT_VERSIONS;

  payload: {
    assessmentVersions: Assessment[] | undefined;
  };
}

export interface SetAssessmentVersion {
  type: typeof SET_ASSESSMENT_VERSION;

  payload: {
    version: number;
    availableIn: string[] | undefined;
  };
}

export interface SetQualifications {
  type: typeof SET_QUALIFICATIONS;

  payload: {
    qualificationData: QualificationData;
  };
}

export interface SetError {
  type: typeof SET_ERROR;
}

export type QualificationsActionTypes =
  | GetQualifications
  | SetQualifications
  | SetError
  | SetQualification
  | SetAssessment
  | GetAssessmentVersions
  | SetAssessmentVersions
  | SetAssessmentVersion;
